<template>
  <!-- Loading spinner -->
  <LoaderSpinner v-if="loading" />

  <!-- Main content -->
  <div v-else class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <!-- Header section -->
    <div class="text-center mb-12">
      <h1 class="text-4xl font-bold text-[#00225E] mb-3">Reports Dashboard</h1>
      <p class="text-lg text-gray-600">
        Select the type of report you want to generate
      </p>
    </div>

    <!-- Report cards grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <!-- Report cards (repeating for each type) -->
      <router-link
        v-for="report in reports"
        :key="report.type"
        :to="{ name: 'reports-filters', params: { type: report.type } }"
        class="bg-white rounded-2xl shadow-lg border border-[#E6EDF7] p-6 hover:shadow-xl hover:border-[#00225E]/30 transition-all duration-300 transform hover:-translate-y-2 flex flex-col group"
      >
        <!-- Icon container with gradient background -->
        <div class="w-[150px] h-[150px] bg-gradient-to-br from-[#00225E]/10 to-[#00225E]/5 rounded-xl flex items-center justify-center mb-5 mx-auto group-hover:from-[#00225E]/15 group-hover:to-[#00225E]/10 transition-colors duration-300">
          <img
            :src="`/icons/reports/${report.type}.png`"
            :alt="report.title"
            class="w-[150px] h-[150px]"
          />
        </div>
        
        <!-- Card content -->
        <div class="flex-1 flex flex-col">
          <!-- <h3 class="text-xl font-semibold text-[#00225E] mb-2 group-hover:text-[#00225E]/90 transition-colors">
            {{ report.title }}
          </h3> -->
          <p class="text-sm text-gray-500 mt-auto">
            {{ report.description }}
          </p>
        </div>
        
        <!-- Hover indicator -->
        <div class="mt-4 h-1 w-0 group-hover:w-full bg-[#00225E] transition-all duration-300"></div>
      </router-link>
    </div>
  </div>
</template>

<script>
import LoaderSpinner from "@/components/CircularLoader.vue";
import { ref, onMounted } from "vue";

export default {
  components: {
    LoaderSpinner,
  },
  setup() {
    const loading = ref(true);
    
    const reports = [
      {
        type: 'hours',
        title: 'Worked Hours',
        description: 'Detailed report of hours worked by team, project or employee'
      },
      {
        type: 'timesheets',
        title: 'Timesheets',
        description: 'Approval status and timesheet compliance reports'
      },
      {
        type: 'clients',
        title: 'Clients',
        description: 'Client billing, projects and financial reports'
      },
      {
        type: 'expenses',
        title: 'Expenses',
        description: 'Expense reports by category, project or employee'
      },
      {
        type: 'bills',
        title: 'Bills',
        description: 'Generated bills and payment status reports'
      },
      {
        type: 'projects',
        title: 'Projects',
        description: 'Project progress, budget and timeline reports'
      }
    ];

    onMounted(() => {
      setTimeout(() => {
        loading.value = false;
      }, 800);
    });

    return {
      loading,
      reports
    };
  },
};
</script>